<template>
  <span>
    <el-button
        v-if="btnType == 'button'"
        icon="el-icon-position"
        size="mini"
        :type="type"
        :plain="plain"
        @click="inviteFn"
    >
      {{ btnText || '投递' }}
    </el-button>
    <el-link
        v-else
        :type="type"
        :underline="false"
        @click="inviteFn"
    >
      {{ btnText || '投递' }}
    </el-link>

    <el-dialog
        :visible.sync="showDialog"
        title="投递简历"
        width="480px"
        v-loading="loaded_list"
        class="tl"
    >
      <div v-if="resume_list && resume_list.length > 0">
        <el-row :gutter="10" v-for="(item, index) in resume_list" :key="index" style="margin-bottom: 5px;">
          <el-col :span="12">
            <el-radio
                v-model="resumes_index"
                :label="index"
            >
              <span v-if="item.json.Basic.title || item.json.Title">
                {{ item.json.Basic.title || item.json.Title }}
              </span>
              <span v-else>简历({{ item.resumes_id }})</span>
              <el-tag
                  v-if="item.is_default * 1 === 1"
                  size="mini"
                  effect="dark"
              >
                默认
              </el-tag>
            </el-radio>
          </el-col>
          <el-col :span="12">
            <span class="resume-txt">
              简历完整度：{{ item.integrity || '0' }}%
            </span>
            <a
                v-if="item.integrity < 100"
                class="el-link el-link--primary"
                :href="link.edit_resume + item.resumes_id"
                target="_blank"
            >
              去完善
            </a>
          </el-col>
        </el-row>
      </div>
      <div v-else>
        <span>暂无简历，</span>
        <a
            class="el-link el-link--primary"
            :href="link.add_resume"
            target="_blank"
        >去新增</a
        >
      </div>
      <div
          slot="footer"
          class="dialog-footer"
          v-if="resume_list && resume_list.length > 0"
      >
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="sendNewResume"
        >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog :title="prompt.title" :visible.sync="prompt.visible" width="30%" class="tl">
      <span>{{ prompt.content }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="prompt.showCancel" @click="prompt.visible = false"
        >取 消</el-button
        >
        <el-button @click="dialogVisible = false">
          <a
              v-if="prompt.resumes_id"
              class="el-link el-link--primary"
              :href="link.edit_resume + prompt.resumes_id"
              target="_blank"
          >
            去完善
          </a>
          <span v-else>确 定</span>
        </el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
import Vue from 'vue'
import {
  Radio,
  Dialog,
  Button, Link
} from 'element-ui'

Vue.use(Radio)
Vue.use(Dialog)
Vue.use(Button)
Vue.use(Link)

// 投递简历
export default {
  name: 'invite-resume',
  components: {},
  props: {
    // publish_ids: 职位id 列表
    publishIds: {
      type: String,
      default: '',
    },
    // 职位信息
    params: {
      type: Object,
    },
    // 视频双选会id
    video_jobfair_id: {
      type: String,
      default: '',
    },
    // 宣讲会id
    career_id: {
      type: String,
      default: '',
    },
    fair_id: {
      type: String,
      default: ''
    },

    // 按钮样式
    btnType: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '投递',
    },
    plain: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    publish_ids () {
      const {publishIds} = this
      const {publish_id} = this.params || {}
      return publishIds || publish_id
    },
    resume () {
      const {resume_list, resumes_index} = this

      if (resume_list && resume_list[resumes_index]) {
        return resume_list[resumes_index]
      } else {
        return null
      }
    },
  },
  created () {
  },
  data () {
    return {
      link: {
        edit_resume: '/seeker/person/resume.html?resumes_id=',
        add_resume: '/seeker/person/resume.html',
      },
      customColors: [
        {color: '#f56c6c', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#5cb87a', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#6f7ad3', percentage: 100},
      ],
      loading: false, //  简历投递
      loaded_list: false, // 简历是否加载完成
      resume_list: [],
      resumes_index: 0,
      showDialog: false,

      // 提示弹窗
      prompt: {
        title: '',
        content: '',
        visible: false,
        showCancel: false,
        url: '',
      },

      // 必填字段
      need: {
        json: {
          Basic: ['truename', 'sex', 'birthday', 'mobile', 'email'],
          Employment: [
            'city',
            'industry',
            'job',
            'job_category',
            'salary',
            'status',
            'time',
            'type',
          ],
        },
        arr: ['Educational'],
        arrJson: {
          Selfappraise: [['content', 10]],
        },
      },
      explain: {
        Basic: '简历个人',
        Employment: '求职意向',
        Selfappraise: '自我描述',
        Educational: '教育经历',
      },
    }
  },
  methods: {
    inviteFn () {
      this.getResume()
    },
    getResume: function () {
      var _self = this
      var params = {}

      _self.loaded_list = true

      this.$util.get('kzp_person', 'resume_list', params).then((res) => {
        _self.loaded_list = false

        if (res.data && res.code == 1) {
          _self.showDialog = true
          _self.resume_list = res.data

          for (var i = 0; i < _self.resume_list.length; i++) {
            if (_self.resume_list[i].is_default * 1 === 1) {
              _self.resumes_index = i
              break
            }
          }
        }else{
          _self.showDialog = false
        }
      }).catch(err => {
        _self.showDialog = false
      })
    },
    sendSuccessFn () {
      let _self = this
      _self.$message({
        message: '投递成功',
        type: 'success',
      })

      const {publish_ids} = this

      // 通知父组件
      _self.$emit('success', {publish_ids: publish_ids})
    },
    perfectResume (resumes_id, content, title, showCancel) {
      let _self = this

      _self.showDialog = false

      _self.prompt = {
        title: title || '去完善简历',
        content: content || '简历完善度需要大于70%',
        visible: true,
        showCancel: showCancel || showCancel === undefined ? true : false,
        resumes_id: resumes_id || 0,
      }
    },
    checkNeed (resume) {
      if (!resume) {
        return '简历缺失'
      }
      // 检查必填项
      const {need, explain} = this

      const {json, arr, arrJson} = need

      const explainStr = '信息不完整'

      for (let key in json) {
        let current = resume[key]
        if (!current) {
          return explain[key] + explainStr
        }
        for (let i = 0; i < json[key].length; i++) {
          if (!current[json[key][i]]) {
            return explain[key] + explainStr
          }
        }
      }

      for (let k = 0; k < arr.length; k++) {
        let currentArr = resume[arr[k]]
        if (!currentArr || currentArr.length <= 0) {
          return explain[arr[k]] + explainStr
        }
      }

      for (let j in arrJson) {
        let currentJson = resume[j]
        if (currentJson && currentJson.length >= 1) {
          currentJson = currentJson[0]
          for (let s = 0; s < arrJson[j].length; s++) {
            let strArr = arrJson[j][s]
            let strItem = currentJson[strArr[0]]
            if (strItem) {
              if (strArr[1] && typeof strItem === 'string') {
                if (strItem.length < strArr[1]) {
                  return explain[j] + explainStr
                }
              }
            } else {
              return explain[j] + explainStr
            }
          }
        } else {
          return explain[j] + explainStr
        }
      }

      return true
    },
    //投递简历
    sendNewResume () {
      let _self = this

      const {json, resumes_id, integrity} = this.resume || {}

      const {
        career_id, video_jobfair_id, fair_id
      } = this

      // 必填字段检查
      const checkResult = this.checkNeed(json)
      if (checkResult !== true) {
        this.perfectResume(resumes_id, checkResult)
        return
      }

      // 简历完善度检查
      if (parseInt(integrity) < 70) {
        this.perfectResume(resumes_id)
        return
      }

      let params = {
        publish_ids: _self.publish_ids,
        resumes_id: resumes_id,
        video_jobfair_id: video_jobfair_id,
        career_id: career_id,
        fair_id: fair_id
      }

      _self.loading = true

      _self.$util
          .post('kzp_person', 'send_new_resume', params)
          .then((res) => {
            _self.loading = false

            const {code, msg} = res
            if (code === 1) {
              _self.showDialog = false
              // 投递成功
              _self.sendSuccessFn()
            } else {
              _self.$message.error(msg)
            }
          })
          .catch(() => {
            // 处理不提示的错误!
          })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Invite/InviteResume.vue